/**
 * "Arrange script" UI state (F-60): which selection's preview dialog is open.
 * Local view state only — the split itself is a doc mutation (arrange.ts).
 *
 * Module SINGLETON for the same reason as the translate store: the F-27
 * registry's `run(ctx)` receives only a BoardSession — there is no prop path
 * from BoardScreen into a toolbar action. Every key is board-scoped and the
 * layer clears the dialog on unmount, so nothing leaks across views.
 */
import { createStore, type StoreApi } from "zustand/vanilla";

/** The selection a preview dialog is open for. */
export interface ArrangeTarget {
  boardId: string;
  sheetId: string;
  /** The F-28 Original Script column (the only column the action shows on). */
  colId: string;
  /** Selected row ids in visual order — the cells offered in the preview. */
  rowIds: readonly string[];
}

export interface ArrangeUiState {
  dialog: ArrangeTarget | null;
  openDialog(target: ArrangeTarget): void;
  closeDialog(): void;
}

export type ArrangeUiStore = StoreApi<ArrangeUiState>;

export const arrangeUi: ArrangeUiStore = createStore<ArrangeUiState>((set) => ({
  dialog: null,
  openDialog: (dialog) => set({ dialog }),
  closeDialog: () => set({ dialog: null }),
}));
